// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { RateTokens } from './type';

const rateTokens: RateTokens = {
  rateFontColor: 'Neutral-text-5',
  rateFontSize: 'Font-14',
  rateFontWeight: 'Weight-regular',
  rateGap: 'Spacing-6',
  rateSize: 'Size-12',
  rateTextGap: 'Spacing-16',
  rateBackgroundColor: 'Neutral-fill-3',
  rateFrontBackgroundColor: 'Lemon-6',
};

export default rateTokens;
